module.exports = __webpack_public_path__ + "img/43800.19cfb4ef.jpg";